module.exports = "//cdn.mxpnl.com/static/asset-cache/39a7e839ffb0bfa4fc59d10abeef7375/iron/common/assets/images/charts/funnel-steps.svg";